export const SYNC_TELEMETRY_EVENT = 'sync-telemetry'

type StorageScope = 'chunks' | 'drafts' | 'submissions'

export type SyncTelemetryEvent =
  | {
      type: 'chunk-retry'
      draftId: string
      sessionId: string
      partNumber: number
      attempts: number
      maxAttempts: number
      errorMessage: string
    }
  | {
      type: 'resume-duration'
      draftId: string
      sessionId: string
      resumeFromPartNumber: number
      durationMs: number
      finalize: boolean
      completed: boolean
      remainingParts: number
    }
  | {
      type: 'storage-pressure'
      scope: StorageScope
      operation: string
      itemId?: string
      errorName: string
      errorMessage: string
    }

function parseError(error: unknown): { name: string; message: string } {
  if (error instanceof Error) {
    return {
      name: error.name || 'Error',
      message: error.message || 'Unknown error',
    }
  }
  return {
    name: 'UnknownError',
    message: String(error),
  }
}

export function isStoragePressureError(error: unknown): boolean {
  const { name, message } = parseError(error)
  const normalizedName = name.toLowerCase()
  const normalizedMessage = message.toLowerCase()

  if (normalizedName.includes('quota')) {
    return true
  }

  return (
    normalizedMessage.includes('quota') ||
    normalizedMessage.includes('storage') ||
    normalizedMessage.includes('disk') ||
    normalizedMessage.includes('space')
  )
}

export function logSyncTelemetry(event: SyncTelemetryEvent): void {
  const payload = {
    ...event,
    timestamp: new Date().toISOString(),
  }

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(SYNC_TELEMETRY_EVENT, { detail: payload }))
  }

  if (event.type === 'storage-pressure') {
    console.error('[SYNC_TELEMETRY]', payload)
    return
  }

  console.info('[SYNC_TELEMETRY]', payload)
}

export function toTelemetryErrorFields(error: unknown): { errorName: string; errorMessage: string } {
  const parsed = parseError(error)
  return {
    errorName: parsed.name,
    errorMessage: parsed.message,
  }
}
